interface PaymentHeaderProps {
  userName: string;
}

export const PaymentHeader = ({ userName }: PaymentHeaderProps) => {
  return null;
};